<mat-card flex="100">
  <mat-card-title class="title-section"> PRD Permissions </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div fxLayout="column" fxLayoutGap="10px">
      <div fxLayout="row">
        <fl-employee-autocomplete
          gdArea="employee"
          [formControl]="employeeCtrl"
          [allCompanies]="false"
        ></fl-employee-autocomplete>
        <button
          mat-button
          mat-icon-button
          aria-label="Clear"
          (click)="clear()"
          class="clear-button"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-form-field class="air-carriers-field">
        <mat-select placeholder="Air Carriers" [formControl]="airCarriersCtrl" multiple>
          <mat-option
            *ngFor="let option of airCarrierOptions$ | async"
            [value]="option.value"
            [disabled]="option.disabled"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="roles-field">
        <mat-select placeholder="Roles" [formControl]="rolesCtrl" multiple>
          <mat-option *ngFor="let option of roleOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button
        mat-raised-button
        (click)="update(); clicked = true"
        [disabled]="form.invalid || clicked"
      >
        Update Permissions
      </button>
    </div>
  </mat-card-content>
</mat-card>
